"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = void 0;
/**
 * Validates that the value is an array.
 * @public
 *
 * @param arg - The argument to validate.
 *
 * @returns A boolean indicating whether the arg is an Array or not.
 *
 * @example
 * ```ts
 * const result = isArray([]);
 * console.log(result);
 * // -> true
 * ```
 */
function isArray(arg) {
    return Array.isArray(arg);
}
exports.isArray = isArray;
//# sourceMappingURL=is-array.js.map